// src/components/GlobalHighlightStyles.js
import React from "react";
import { Global, css } from "@emotion/react";
import { useThemeUI } from "theme-ui";

const GlobalHighlightStyles = () => {
  const { theme } = useThemeUI();
  const colors = theme.colors || {};

  const primary = colors.primary || "#ff0000";
  const surfaceContainerLow = colors.surfaceContainerLow || "transparent";

  return (
    <Global
      styles={css`
        @keyframes flashHighlight {
          0% {
            box-shadow: 0 0 0 0 ${primary}00;
          }
          25% {
            box-shadow: 0 0 0 3px ${primary};
          }
          75% {
            box-shadow: 0 0 0 0 ${primary}00;
          }
          100% {
            box-shadow: 0 0 0 0 ${primary}00;
          }
        }

        /* Shared flash utility */
        .flash-highlight {
          animation: flashHighlight 2s ease-out 0s 2 forwards; /* ~4s total */
        }
      `}
    />
  );
};

export default GlobalHighlightStyles;
